import './kp-generate-side-menu.less';

import * as angular from 'angular';
import type {ICompileService, IParseService, ISCEService} from 'angular';
import GenerateMenuController from './kp-generate-menu.controller';
import {isGoToMenuItemAction} from '../../../services/defined-action-performer';

/**
 * @ngdoc directive
 * @name kpGenerateSideMenu
 * @module portaro.components.main-menu
 *
 * @restrict E
 *
 * @param {Array<menuItem>} menuStructure Menu structure definition
 * @param {expression} onClick On click hook
 *
 * @description
 * Internal directive for generating menu HTML structure from given input data
 */
export default class GenerateSideMenuDirective {
    static directiveName = 'kpGenerateSideMenu';

    restrict = 'E';
    controller = GenerateMenuController;
    controllerAs = 'gsmdc';

    /*@ngInject*/
    constructor(private $parse: IParseService,
                private $compile: ICompileService,
                private $sce: ISCEService) {
    }

    preLink($scope, $element, $attrs, controller: GenerateMenuController) {
        const menuStructure = this.$parse($attrs.menuStructure)($scope);

        controller.setMenuStructure(menuStructure);

        const onClickHandler = this.$parse($attrs.onClick);
        if (onClickHandler) {
            controller.setOnClickHandler(onClickHandler);
        }

        const generatedMenu = angular.element(this.generateMenu(menuStructure));
        $element.append(generatedMenu);
        this.$compile(generatedMenu)($scope);
    }

    private generateMenu(menuStructure) {
        return `
            <ul class="kp-mm-nav-list">
                ${menuStructure.map((menuItem, index) => {
            if (menuItem.type === 'user') {
                return '';
            } else if (menuItem.submenu) {
                return this.generateMultiMenuItem(menuItem, index);
            } else {
                return this.generateSingleMenuItem(menuItem, index);
            }
        }).join('')}
            </ul>
        `;
    }

    private generateSingleMenuItem(menuItem, index) {
        return `<li class="kp-mm-nav-item kp-mm-nav-item-heading sidemenu-separator">
                    <a class="kp-mm-nav-responsive-tab kp-mm-nav-title" href="${this.generateHref(menuItem)}" ng-click="gsmdc.performClick($event, ${index})"><span>${menuItem.text}</span></a>
                </li>`;
    }

    private generateMultiMenuItem(menuItem, index) {
        return `
            <li class="kp-mm-nav-item kp-mm-nav-item-heading sidemenu-separator">
                <a class="kp-mm-nav-responsive-tab kp-mm-nav-title kp-mm-nav-active" href="javascript:void(0)"><span>${menuItem.text}</span></a>
                <nav class="kp-mm-nav-responsive-tabs kp-mm-nav">
                    <ul class="kp-mm-nav-list">
                        ${menuItem.submenu.map((element, subIndex) => `<li class="kp-mm-nav-item kp-mm-nav-item-heading">${this.generateSingleSubmenuItem(element, index, subIndex)}</li>`).join('')}
                    </ul>
                </nav>
            </li>
        `;
    }

    private generateSingleSubmenuItem(menuItem, index, subIndex) {
        return `<a class="kp-mm-nav-responsive-tab kp-mm-nav-title" href="${this.generateHref(menuItem)}" ng-click="gsmdc.performClick($event, ${index}, ${subIndex})"><span>${menuItem.text}</span></a>`;
    }

    private generateHref(menuItem) {
        const action = menuItem.action;
        if (isGoToMenuItemAction(action)) {
            return action.path;
        }
        return this.$sce.trustAsHtml('javascript:void(0)');
    }

}